"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderedRegionOptions = void 0;
const country_1 = require("../enums/country");
const region_1 = require("../region");
const COUNTRY_NAME_TO_CODE = {
    [country_1.CountryNames.Canada]: country_1.CountryCode.CA,
    [country_1.CountryNames.UnitedStates]: country_1.CountryCode.US,
    [country_1.CountryNames.Australia]: country_1.CountryCode.AU,
};
const buildRegionOptions = (countryName) => {
    return (0, region_1.getRegionOptions)(COUNTRY_NAME_TO_CODE[countryName]).map((option) => ({
        label: option.label,
        value: option.code,
        countryName,
    }));
};
const getOrderedRegionOptions = (organizationCountry) => {
    const canadaOptions = buildRegionOptions(country_1.CountryNames.Canada);
    const unitedStatesOptions = buildRegionOptions(country_1.CountryNames.UnitedStates);
    const australiaOptions = buildRegionOptions(country_1.CountryNames.Australia);
    if (organizationCountry === country_1.OrganizationCountry.Canada) {
        return [...canadaOptions, ...unitedStatesOptions, ...australiaOptions];
    }
    if (organizationCountry === country_1.OrganizationCountry.Australia) {
        return [...australiaOptions, ...unitedStatesOptions, ...canadaOptions];
    }
    return [...unitedStatesOptions, ...canadaOptions, ...australiaOptions];
};
exports.getOrderedRegionOptions = getOrderedRegionOptions;
